import { Flash as PrimerFlash, FlashProps as PrimerFlashProps } from '@primer/react';

type Props = {} & PrimerFlashProps;

const Flash = ({ sx, ...props }: Props) => <PrimerFlash sx={{ overflowWrap: 'break-word', ...sx }} {...props} />;

export default Flash;
export type { Props as FlashProps };
